// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.tours.RentalManagerUserPropertyToursWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { GetToursCountForListingsRequestWebDto, UserPropertiesToursCountDto, UserPropertyToursDto } from '../..';

interface ToursParams {
  propertyId: string;
}

export const RentalManagerUserPropertyToursWebApiHandler_getCountForListings_Path =
  '/api/web/v1/users/properties/tours/getCountForListings';

/**
 * Get tours count for listings given a list of listing ids
 */
export const RentalManagerUserPropertyToursWebApiHandler_getCountForListings = (
  postData: GetToursCountForListingsRequestWebDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, GetToursCountForListingsRequestWebDto, Array<UserPropertiesToursCountDto>>({
    endpoint: RentalManagerUserPropertyToursWebApiHandler_getCountForListings_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_Path =
  '/api/web/v1/users/properties/tours/getExternalTourProviders';

/**
 * Get a list of supported external tour providers
 */
export const RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders = (
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, never, Array<string>>({
    endpoint: RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertyToursWebApiHandler_tours_Path = '/api/web/v1/users/properties/tours';

/**
 * Get external tours and vr models for a property and its floor plans/units
 */
export const RentalManagerUserPropertyToursWebApiHandler_tours = (
  getParams: ToursParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<ToursParams, never, UserPropertyToursDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyToursWebApiHandler_tours_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
